import { ParentComponent } from 'solid-js'

const CardText: ParentComponent = (props) => {
  return <p class="card-text">
    {props.children}
  </p>
}

export default CardText